export default __webpack_public_path__ + "static/enceinte3-737245ecaf294597911ffaf8590ef14f.jpg";